<template>
    <div class="ResidentialLayout">
        <div>
            <nav class="navbar navbar-light navbar-expand-md navigation-clean">
                <b-container fluid>
                    <b-col>
                        <a id="navbar-brand" class="navbar-brand pointer"><img v-bind:src="sitelogo" /></a>
                    </b-col>
                    <b-col>
                        <h3 style="color:white;white-space:nowrap;overflow-x:unset;">Currently Checked In Users</h3>
                    </b-col>
                    <b-col>
                        <a href="/Identity/Account/Login?ForceLoginPage=true" style=" float:right;">
                            <h6 style="color:white;">
                                Click here to use password
                                <font-awesome-icon :icon="['fa', 'external-link-square-alt']" class="pointer">

                                </font-awesome-icon>

                            </h6>
                        </a>
                    </b-col>
                </b-container>
            </nav>
        </div>
        <div class="container-fluid container-fill">
            <b-row class="justify-content-md-center">
                <b-col align-self="center">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-4" style="display: table;" v-for="residence in Residences">
                                <div class="paper">
                                    <h3 class="center-text">{{residence.Name}}</h3>
                                    <div class="col-md-4" v-for="user in CheckedInUsers">
                                        <div v-if="residence.Id == user.ResidenceID">
                                            <b-button style="padding-left:0" variant="link" @click="OpenPinModal(user)"><h4>{{user.FullName}}</h4></b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-modal ref="pin-modal" :title="'Enter pin'" id="pinModal" hide-footer>
                    <b-container fluid>
                        <b-row class="modal-btn-row">
                            <PinInput DigitLength="6" AuthenticateMethod="ResidentialPinLogin/LoginWithPin" RedirectTo="/Residential" :AdditionalPayload="{EmployeeID: ClickedOnUser.EmployeeID}" @update='shakeForm' />
                        </b-row>
                    </b-container>
                </b-modal>
            </b-row>

        </div>
    </div>
    
</template>
<script>
    //import services
    //import { UserAPI } from '../../services/api/Core/UserAPI.js';
    //import components
    import $ from 'jquery'
    //window.$ = JQuery

    import PinInput from '../Residential/PinInput.vue';
    //import ChildrenPane from '../Children/ChildrenPane.vue';
    //import DocumentsPane from '../../Core/RecordComponents/DocumentsPane.vue';
    //import Logout from '../../Core/UI/Logout.vue';

    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faExternalLinkSquareAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faExternalLinkSquareAlt);

    export default {
         data: function () {
            return {
                sitelogo: "/images/OliveCrestLogo_Banner_Portal.png",
                CheckedInUsers: [],
                ClickedOnUser: {},
                Residences: []
            };
        },
        methods: {
            GetCheckedInUsers() {
                this.$MasterAPI.ExecuteRequest("GET", "ResidentialPinLogin/GetCheckedInUsers", {}, this.GetCheckedInUsersSuccess, this.GetCheckedInUsersError, true);
            },
            GetCheckedInUsersSuccess(response) {
                this.CheckedInUsers = response.data.data;
            },
            GetCheckedInUsersError(response) {
                this.$refs['incorrect-modal'].show();
            },
            GetResidences() {
                this.$MasterAPI.ExecuteRequest("GET", "ResidentialPinLogin/GetResidences", {}, this.GetResidencesSuccess, this.GetResidencesError, true);
            },
            GetResidencesSuccess(response) {
                this.Residences = response.data.data;
            },
            GetResidencesError(response) {
                this.$refs['incorrect-modal'].show();
            },
            shakeForm() { 
                //distance of shake
                var distance = 20;  
                $(document).ready(function () {
                    //amount of shakes
                    for( var i = 0; i <= 4; i++ ) {   
                    $( '#pinModal' ).animate( { 
                         'margin-left': '+=' + ( distance = -distance ) + 'px',
                         'margin-right': '-=' + distance + 'px'
                      }, 50);  
                    }
                   
                });
                //reset position
                $('#pinModal').css('margin-left', '0px');
                $('#pinModal').css('margin-right', '0px');
            },
 
            OpenPinModal(user) {
                this.ClickedOnUser = user;
                this.$refs['pin-modal'].show();
            },
            HidePinModal() {
                this.$refs['pin-modal'].hide();
            },
        },
        mounted() {
            this.GetCheckedInUsers();
            this.GetResidences();
        },
        components: {
            PinInput
        },
    }
</script>


<style scoped>
    .upper-right {
        position:absolute;
        top:0;
        right:40px;
    }
    .animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

.animated.hinge {
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
}

.animated.bounceIn,
.animated.bounceOut {
  -webkit-animation-duration: .75s;
  animation-duration: .75s;
}

.animated.flipOutX,
.animated.flipOutY {
  -webkit-animation-duration: .75s;
  animation-duration: .75s;
}

@-webkit-keyframes shake {
  from, to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%, 30%, 50%, 70%, 90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%, 40%, 60%, 80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

@keyframes shake {
  from, to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%, 30%, 50%, 70%, 90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%, 40%, 60%, 80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

.shake {
  -webkit-animation-name: shake;
  animation-name: shake;
}
</style>